<template>
    <div class="item_sidebar multi-select-item" :class="{'active': moreFields}">
        <div class="title title_m_b">{{title}}</div>
        <div class="wrapper_input">
	        <v-select class="small flex vs__taggable" :options="selectOptions"
	                  v-model="selectData.selected"
	                  @input="inputChanged"
	                  taggable multiple
	                  append-to-body>
		        <template v-slot:no-options="{ search, searching }">
			        <em style="opacity: 0.7;padding: 5px">
				        Type your <code>classname</code> and <b>hit enter</b> to add it.
			        </em>
		        </template>
	        </v-select>
        </div>
    </div>
</template>

<script>

export default {
    name: 'MultiSelectItem',
    components: {

    },
    props: ['title', 'value', 'options'],
    data: function(){
        return {
            moreFields: false,
            selectData: {
                option: this.options,
                selected: this.value || [],
            },
        }
    },
    computed: {
        selectOptions(){
            let options = [];
            let ss = this.selectData.selected || [];
            for (let index = 0; index < ss.length; index++) {
                options.push(this.selectData.selected[index])
            }
            return options;
        }
    },
    methods: {
        inputChanged(){
            this.$emit('updated', this.selectData.selected || []);
        },
        addOption(){
            console.log('addOption');
        }
    },
    created(){
        if(this.title == 'Width') this.inputChanged();
    }
}
</script>

<style lang="scss">
.item_sidebar.multi-select-item .vs__taggable .vs__dropdown-toggle {
	height: auto;
}
.app-page-editor .select2-container--default .select2-selection--multiple .select2-selection__choice {
    margin-top: 1px;
}
.app-page-editor .main .select2-container--default .select2-selection--multiple,
.app-page-editor .main .select2-container--default.select2-container--focus .select2-selection--multiple {
    border-radius: 2px;
    min-width: auto;
    padding-bottom: 0;
    padding-top: 0;
    background-position: calc(100% - 10px) 11px;
    background-size: 8px;
}
</style>
